export enum TicketStatus {
    InProgress = 'En curso',
    Resolved = 'Resuelta',
}

export enum TicketTimelineStatus {
    InProgress = 'En progreso',
    Resolved = 'Resuelta',
    Open = 'Abierta',
    WaitingForAnswer = 'Esperando respuesta',
    Reopened = 'Reabierta',
}

export enum TicketTimelineStatusCodes {
    InProgress = 'INPROGRESS',
    Solved = 'SOLVED',
    Opened = 'OPENED',
    WaitingForCustomer = 'WAITINGCUSTOMER',
    Reopened = 'REOPENED',
    Ongoing = 'ONGOING'
}
export interface CaseReasonDetails {
    caseReasonDetailId: number
    descriptionWeb: string
    orderToShow: number
}

export interface TicketModel {
    caseReasonId: number
    descriptionWeb: string
    caseReasonDetails: CaseReasonDetails[]
    orderToShow: number
}

export interface CaseProduct {
    caseProductId: number
    productName: string
    orderToShow: number
}

export interface CaseFiles {
    name: string
    file: string
}

export interface SaveCaseRequest {
    caseReasonId: number
    caseReasonDetailId: number
    caseProductId: number
    subject: string
    description: string
    otherEmail: string
    otherPhone: string
    caseFiles: CaseFiles[]
    acceptPrivacyPolicy: boolean
}

export interface TicketHistoryItem {
    caseId: number
    caseReasonDetail: string
    subject: string
    createdDate: string
    caseSource: string
    caseSourceCode?: string
    status: string
    caseNumber: string
    caseReason: string
    closeDate?: string
    statusCode?: string
}

export interface TicketDetail extends TicketHistoryItem {
    description: string
    caseFiles: CaseFiles[]
    nameUser: string
    canReopen?: boolean
    caseHistoricStatusList?: { status: string; date: string }[]
    statusOneforce: TicketStatus
    otherEmail?: string
    otherPhone?: string
    nameContact?: string
}

export interface SaveCaseReopenRequest {
    caseId: string
    caseNumber: string
    subject: string
    description: string
    expandedDescription: string
    otherEmail: string
    otherPhone: string
    caseFiles: CaseFiles[]
    acceptPrivacyPolicy: boolean
}